

export const fieldsCitas = `
  cita {

    id
    token
    fechaCreacion
    consultacitamedicaSet {
      token
      fechaCreacion
      estado
      descansomedicoSet {
        id
      }
    }

    detallescitaSet {
      id
      detailsSeguro
      detallesTitulares
    }
  
    cobSeleccionada {
      descripcion
      id
    }
    tipocontingencia {
      id
      descripcion
    }
    tipoServicios
    derivacion
    codderivacion
    fecderivacion
    fecfinderivacion
    derivacionCaducada
    fechaCita
    horaCita
    usuarioCreador{
      username
    }
  
    urlsMspPaciente
    urlsMspTitular1
    urlsMspTitular2
    urlsMspTitular3
    
    urlDerivacion
    urlCodigoDer
    url007Recibido

    urlSolImgDer
    urlSolLabDer
    urlSolProcDer

    urlOtrosDocumentos

    estado
    estadoSignosvital
    estadoActual
    estadoRevision
    establecimiento{
      id
      Descripcion
    }
    paciente{
      id
      persona {
        primerNombre
        primerApellido
        identificacion
        fechaNacimiento
        ocupacion {
          descripcion
        }
      }

    }
    doctor {
      id
      idPersona {
        primerNombre
        primerApellido
        identificacion
      }
      especialidad {
        descripcion
        codEsp
      }
    }

    
  }
`;
